import { useMutation } from "@tanstack/react-query";
import { googleLoginApi } from "./auth.api";
import { QUERY_KEYS } from "../querykeys";

export const useGoogleLoginMutation = () => {
   return useMutation({
        mutationKey:[QUERY_KEYS.GOOGLE_LOGIN],
        mutationFn: googleLoginApi,
    })
}